import Headers from '@/component/Headers';
import FollowPopup from '@/component/popups/ui-3/FollowPopup';
import { getLoyaltyPoint } from '@/Redux/futures/loyalty-point/actions';
import { curLoyaltyPoint } from '@/Redux/selector';
import { formatDataNumberToen } from '@/utils/helper';
import UseResponsive from '@/utils/hooks/useResponsive';
import frameBottom from '@assets/web-v3-images/frame-loyalty-point-bottom.png';
import frameTop from '@assets/web-v3-images/frame-loyalty-point-top.png';
import imgbottom from '@assets/web-v3-images/icons/Button.png';
import imgCoin from '@assets/web-v3-images/icons/crown-coin-icon.png';
import imgIconTop from '@assets/web-v3-images/icons/img.png';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import LoyaltyPointHistory from './components/LoyaltyPointHistory';
import QuickRule from './components/QuickRule';
import RedeemMilestone from './components/RedeemMilestone';
import RedeemRewards from './components/RedeemRewards';

export default function LoyaltyPoint() {
	const { t } = useTranslation()
	const dispatch = useDispatch();
	const contentRef = useRef(null);
	const quickRuleRef = useRef(null);
	const [contentHeight, setContentHeight] = useState(2810);
	const [showFollowPopup, setShowFollowPopup] = useState(false);
	const [showWithdrawPopup, setShowWithdrawPopup] = useState(false);

	const { loyaltyPoint, isMaster } = useSelector(curLoyaltyPoint);

	useEffect(() => {
		const expiresInDays = loyaltyPoint?.expires_in_days;

		if (expiresInDays != null && expiresInDays <= 3) {
			const hasShown = localStorage.getItem('loyalty-point-expire-popup');

			if (!hasShown) {
				setShowWithdrawPopup(true);
				localStorage.setItem('loyalty-point-expire-popup', 'true');
			}
		}
	}, [loyaltyPoint?.expires_in_days]);


	useEffect(() => {
		if (loyaltyPoint?.available_withdraw_milestone >= 1000) {
			const hasShown = localStorage.getItem('loyalty-point-withdraw-popup');

			if (!hasShown) {
				setShowFollowPopup(true);
				localStorage.setItem('loyalty-point-withdraw-popup', 'true');
			}
		}
	}, [loyaltyPoint?.available_withdraw_milestone]);

	useEffect(() => {
		dispatch(getLoyaltyPoint({}));
	}, [dispatch]);

	useLayoutEffect(() => { // dùng để lấy chiều cao nội dung của màn dùng cho UseResponsive
		if (!contentRef.current) return;

		// Đo lần đầu ngay khi mount
		const measure = () => {
			setContentHeight(contentRef.current.scrollHeight);
		};
		measure();

		// Theo dõi thay đổi kích thước khi content thay đổi 
		const observer = new ResizeObserver(() => {
			measure();
		});
		observer.observe(contentRef.current);

		return () => observer.disconnect();
	}, []);

	return (
		<UseResponsive height={contentHeight}>
			<div ref={contentRef}>
				<div className="relative w-full">
					<img src={frameTop} className="w-full h-auto block" alt="" />
					<div className="absolute top-0 w-full pt-15">
						<Headers
							title={t('loyalty_point.loyalty_point_wallet')}
							titleColor="rgba(255, 255, 255, 1)"
							trailIcon={<img src={imgIconTop} alt='' />}
							onTrailIconClick={() => {
								quickRuleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
							}}
						/>
					</div>
					<div className="text-center absolute bottom-40 left-1/2 -translate-x-1/2 z-1">
						{/* Title */}
						<p className="text-[rgba(113,59,18,1)] font-extrabold text-3xl mb-2 tracking-wide">
							{t("loyalty_point.your_loyalty_points")}
						</p>

						{/* Coin + Số điểm */}
						<div className="flex items-center justify-center gap-3">
							<img src={imgCoin} className="w-12 h-12 sm:w-15 sm:h-15" alt="" />
							<span className="bg-gradient-to-b from-[#ff9268] to-[#e0522a] bg-clip-text text-transparent font-extrabold text-5xl sm:text-6xl leading-none">
								{formatDataNumberToen(loyaltyPoint?.balance) || 0}
							</span>
						</div>
					</div>
				</div>
				<div className="relative w-full -mt-[2px] z-10">
					<img
						src={frameBottom}
						className="absolute inset-0 w-full h-full object-fill"
						alt=""
					/>
					<div className="relative w-full px-4 py-6">
						<RedeemMilestone data={loyaltyPoint} />
						<RedeemRewards
							options={loyaltyPoint?.withdraw_milestones}
							remaining={loyaltyPoint?.today_withdraw_count}
							total={loyaltyPoint?.withdraw_max_per_day}
							balance={loyaltyPoint?.balance}
							today_withdrawn={loyaltyPoint?.today_withdrawn} // check xem đã rút chưa
						/>
						<LoyaltyPointHistory />
						<QuickRule content={loyaltyPoint?.quick_rule?.content} quickRuleRef={quickRuleRef} />
					</div>
				</div>

				{/* {showWithdrawPopup && (
					<FollowPopup
						open={showWithdrawPopup}
						onOpenChange={setShowWithdrawPopup}
						type="4"
						textBtn={t("loyalty_point.withdraw_LP")}
						handleClick={() => {
							setShowWithdrawPopup(false);
						}}
					/>
				)} */}
				{/* {showFollowPopup && (
					<FollowPopup
						open={showFollowPopup}
						onOpenChange={setShowFollowPopup}
						type="5"
						textBtn={t("loyalty_point.withdraw_LP")}
						handleClick={() => {
							setShowFollowPopup(false);
						}}
					/>
				)} */}
			</div>
		</UseResponsive>
	)
}
